import { MouseEventHandler, useCallback } from "react";
import { useConfirmationDialog } from "@chhjit/react-components";

const DEFAULT_TITLE = "SMS text policy";
const DEFAULT_MESSAGE = (
  <>
    By providing your phone number, you are providing your electronic signature
    expressly authorizing College HUNKS to contact you by text, or phone at the
    home or mobile phone number provided to contact you in order to confirm your
    estimate and manage details of your job.
    <br />
    You may opt-out to specific updates at any time by replying STOP to any
    message received. Messaging and data rates may apply.
  </>
);
const DEFAULT_CLOSE_BUTTON = "Close";

type SmsPolicyConfig = {
  title?: string;
  message?: string;
  closeButtonText?: string;
};

export const useSmsPolicy = (config?: SmsPolicyConfig) => {
  const { openConfirmation } = useConfirmationDialog({
    title: config?.title || DEFAULT_TITLE,
    message: config?.message || DEFAULT_MESSAGE,
    cancelButtonText: config?.closeButtonText || DEFAULT_CLOSE_BUTTON,
    hideConfirmButton: true,
  });

  const openSmsPolicy: MouseEventHandler<HTMLSpanElement> = useCallback(
    (e) => {
      e.preventDefault();
      e.stopPropagation();

      openConfirmation(() => {});
    },
    [openConfirmation],
  );

  return openSmsPolicy;
};
